export default __webpack_public_path__ + "static/media/eth-text-black.6daf650e.svg";